<template>
<div class="chapter">
<div class="inner_page">
<p class="bk-title"><span>The Hangmen of Sleepy Valley</span></p>
<p class="bk-title1"><span>A Twister and Chuckaluck Mystery</span></p>
<p class="authorname"><span>Brett Halliday writing as Davis Dresser</span></p>
<p class="publisher"><span><img alt="image" class="svg" src="images/fig_01.jpg"/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?1413a0fd